import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/Gallery';
import BeforeAfter from './components/BeforeAfter';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import CTA from './components/CTA';
import ServiceAreas from './components/ServiceAreas';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <ServiceAreas />
      <Gallery />
      <BeforeAfter />
      <Testimonials />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}